import {createSlice} from '@reduxjs/toolkit';
import {getObjectProp} from '../../utils/helpers';

const initialState = {
  authenticated: false,
  loading: true,
  token: undefined,
  expiresAt: undefined,
  roles: undefined,
  username: undefined,
  email: undefined,
  verified: undefined,
  userId: undefined,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: create => ({
    setLoggedIn: create.reducer((state, {payload}) => ({
      ...state,
      authenticated: true,
      loading: false,
      token: getObjectProp(payload, 'access_token') || undefined,
      email: getObjectProp(payload, 'username') || undefined,
      username: getObjectProp(payload, 'username') || undefined,
      expiresAt: getObjectProp(payload, 'expires_at') || undefined,
      roles: getObjectProp(payload, 'roles') || undefined,
      verified: getObjectProp(payload, 'verified') || undefined,
    })),
    setLoggedOut: create.reducer(() => ({
      ...initialState,
      loading: false,
    })),
    setAuthUser: create.reducer((state, {payload}) => ({
      ...state,
      authenticated: true,
      loading: false,
      token: getObjectProp(payload, 'access_token') || undefined,
      email: getObjectProp(payload, 'email') || undefined,
      username: getObjectProp(payload, 'username') || undefined,
      roles: getObjectProp(payload, 'roles') || undefined,
      verified: getObjectProp(payload, 'verified') || undefined,
      userId: getObjectProp(payload, 'id') || undefined,
    })),
    setAuthLoading: create.reducer((state, {payload}) => ({
      ...state,
      loading: payload,
    })),
  }),
});

export const authState = state => state.auth;

export const {setLoggedIn, setLoggedOut, setAuthLoading, setAuthUser} =
  authSlice.actions;

export default authSlice.reducer;
